module.exports = __webpack_public_path__ + "static/artist-development-results-mobile-b62ccb0c66e96a73a27e9ae696b09a7b.webp";